import React from 'react';
import Icon from '../../../components/AppIcon';

const FeatureAccessCard = ({ featureAccess, plan }) => {
  const features = [
    { key: 'aiFeatures', label: 'AI Features', icon: 'Brain', description: 'AI-powered lead scoring and automation' },
    { key: 'advancedAnalytics', label: 'Advanced Analytics', icon: 'BarChart3', description: 'Detailed performance insights' },
    { key: 'apiAccess', label: 'API Access', icon: 'Code', description: 'Programmatic access to your data' },
    { key: 'teamCollaboration', label: 'Team Collaboration', icon: 'Users', description: 'Multi-user workspace features' },
    { key: 'customIntegrations', label: 'Custom Integrations', icon: 'Plug', description: 'Connect with third-party tools' },
    { key: 'prioritySupport', label: 'Priority Support', icon: 'Headphones', description: '24/7 dedicated support' }
  ];

  const hasAccess = (key) => {
    if (!featureAccess) return plan?.name === 'Enterprise';
    return featureAccess?.[key] === true;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1">
      <div className="flex items-center space-x-3 mb-6">
        <div className="p-2 bg-primary/10 rounded-lg">
          <Icon name="Shield" size={20} className="text-primary" />
        </div>
        <h3 className="text-lg font-semibold text-foreground">Feature Access</h3>
      </div>
      <div className="space-y-3">
        {features?.map((feature) => {
          const access = hasAccess(feature?.key);
          return (
            <div key={feature?.key} className="flex items-center justify-between p-3 rounded-lg bg-muted/30">
              <div className="flex items-center space-x-3">
                <Icon name={feature?.icon} size={16} className={access ? 'text-primary' : 'text-muted-foreground'} />
                <div>
                  <p className="text-sm font-medium text-foreground">{feature?.label}</p>
                  <p className="text-xs text-muted-foreground">{feature?.description}</p>
                </div>
              </div>
              <div className={`flex items-center space-x-1 ${
                access ? 'text-success' : 'text-muted-foreground'
              }`}>
                <Icon name={access ? 'CheckCircle' : 'XCircle'} size={18} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FeatureAccessCard;